import palette from './palette';

const calendar = {
  MuiDateCalendar: {
    styleOverrides: {
      root: {
        width: '300px',
        padding: '16px',
      },
    },
  },
  MuiMonthCalendar: {
    styleOverrides: {
      root: {
        padding: 0,
        width: '267px',
        columnGap: 0,
        marginTop: '10px',
        '&:hover .Mui-selected': {
          color: palette.red[600],
          backgroundColor: 'transparent',
        },
        '&:has(.MuiMonthCalendar-button:not(.Mui-selected):hover) .Mui-selected':
          {
            color: palette.red[600],
            backgroundColor: 'transparent',
          },
      },
      button: {
        width: '89px',
        height: '35px',
        borderRadius: '4px',
        padding: 0,
        '&:hover': {
          color: palette.common.white,
          background: palette.red[600],
        },
      },
    },
  },
  MuiDayCalendar: {
    styleOverrides: {
      root: {
        '& .MuiDayCalendar-monthContainer': {
          '&:has(.MuiPickersDay-root:not(.Mui-selected):hover) .Mui-selected': {
            color: palette.red[600],
            backgroundColor: 'transparent',
          },
          '&:hover .Mui-selected': {
            color: palette.red[600],
            backgroundColor: 'transparent',
          },
        },
      },
      weekContainer: {
        margin: '8px 0',
        justifyContent: 'start',
      },
    },
  },

  MuiPickersDay: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        width: '28px',
        height: '28px',
        margin: '0 5px',
        '&:hover': {
          color: palette.common.white,
          background: palette.red[600],
        },
      },
    },
  },
};
export default calendar;
